/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Action_ListInputs */

const en_recipe_action_list = /** @type {(inputs: Recipe_Action_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shop`)
};

const de_recipe_action_list = /** @type {(inputs: Recipe_Action_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einkaufen`)
};

/**
* | output |
* | --- |
* | "Shop" |
*
* @param {Recipe_Action_ListInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_action_list = /** @type {((inputs?: Recipe_Action_ListInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Action_ListInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_action_list(inputs)
	return en_recipe_action_list(inputs)
});